import styled from 'styled-components';
import { PhotoCarouselDotMixin } from '../../mixins/components/PhotoCarouselDotMixin';
export var StyledPhotoCarouselDot = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledPhotoCarouselDot",
  componentId: "c11n-8-111-1__sc-13cmuns-0"
})(["", ""], PhotoCarouselDotMixin);